import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/var/www/html/src/components/Layout/QuickStarts.tsx";
import { Img } from 'components/shared';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Questions = makeShortcode("Questions");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Verify API Troubleshooting`}</h1>
    <p>{`MessageBird offers multiple tools to enable you to quickly understand any unexpected behavior between the MessageBird Verify API and your application.`}</p>
    <h2>{`Explore the Message Logs in your Dashboard`}</h2>
    <p>{`If you run into issues with SMS or Voice message and token delivery, the best place to start troubleshooting is in the `}<a parentName="p" {...{
        "href": "https://dashboard.messagebird.com/en/messages/list"
      }}>{`Message Logs in your MessageBird Dashboard.`}</a></p>
    <Img src="/img/screenshots/quickstarts/message-logs.png" alt="Message Logs" width="650px" align="middle" mdxType="Img" />
    <p>{`There you can find an overview of the sent and received messages for the last 30 days, and you can `}<a parentName="p" {...{
        "href": "https://dashboard.messagebird.com/en/messages/export"
      }}>{`export`}</a>{` messages older than 30 days.`}</p>
    <p>{`Select the eye symbol on the far right side of the logs to drill into each specific message for information such as ID, Originator, Send Time, Message and Summary.`}</p>
    <p>{`You can filter the SMS logs by Status (e.g. filter by undelivered) using the `}<inlineCode parentName="p">{`Filter`}</inlineCode>{` button on the top right.`}</p>
    <h2>{`General API error codes`}</h2>
    <p>{`If you've received an error response and code from MessageBird, you can troubleshoot the error by exploring the general `}<a parentName="p" {...{
        "href": "/docs/handling-errors"
      }}>{`API Error Codes.`}</a></p>
    <p>{`In case of an API error, the body of the response includes a `}<inlineCode parentName="p">{`json`}</inlineCode>{` formatted response that tells you exactly what's wrong.`}</p>
    <Questions mdxType="Questions" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      